import React from 'react'
import { navigation } from "../controller/control"
import { NavLink } from 'react-router-dom'

export default function Navigation() {
    return (
        <>
            {navigation.map((nav, i) => <li key={i}><NavLink to={nav.link}>{nav.name}</NavLink></li>)}
        </>
    )
}
